import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react';

export type PhotoCarouselApi = {
  count: number;
  /** 0-based logical slide */
  index: number;
  canSlide: boolean;
  /** Current slide is a video */
  isVideo: boolean;
  /** Slideshow autoplay is running */
  playing: boolean;
  prev: () => void;
  next: () => void;
  togglePlay: () => void;
};

type PhotoCarouselContextValue = {
  api: PhotoCarouselApi | null;
  setApi: (api: PhotoCarouselApi | null) => void;
};

const PhotoCarouselContext = createContext<PhotoCarouselContextValue | null>(
  null,
);

export function PhotoCarouselProvider({ children }: { children: ReactNode }) {
  const [api, setApiState] = useState<PhotoCarouselApi | null>(null);
  const setApi = useCallback((next: PhotoCarouselApi | null) => {
    setApiState(next);
  }, []);
  const value = useMemo(() => ({ api, setApi }), [api, setApi]);
  return (
    <PhotoCarouselContext.Provider value={value}>
      {children}
    </PhotoCarouselContext.Provider>
  );
}

export function usePhotoCarouselApi(): PhotoCarouselApi | null {
  return useContext(PhotoCarouselContext)?.api ?? null;
}

export function usePhotoCarouselRegister(): (
  api: PhotoCarouselApi | null,
) => void {
  const ctx = useContext(PhotoCarouselContext);
  return ctx?.setApi ?? (() => {});
}
